// src/Routes/Prompts/EditPrompt.tsx
import React, { useState, useEffect, useContext } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { GoogleAnalyticsContext } from "../../Hooks/GoogleAnalyticsContext";
import { useAuthenticatedFetch } from "../../Hooks/useFetch";
import config from "../../config";
import PromptEditor from "../../Components/HighLevelComponents/UserPromptManagement/components/PrompEditor.tsx/PromptEditor";
import { Prompt } from "../../Components/HighLevelComponents/UserPromptManagement/components/types";
import SidebarLayout from "../../Components/Layout/SidebarLayout";
import { HashLoader } from "react-spinners";

const EditPrompt: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const [prompt, setPrompt] = useState<Prompt | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const navigate = useNavigate();
  const { logEvent } = useContext(GoogleAnalyticsContext);

  const { res: promptRes, callAPI: fetchPrompt } = useAuthenticatedFetch({
    url: `${config.API_URI}/api/prompt/${id}`,
    method: "GET",
  });

  useEffect(() => {
    fetchPrompt();
    logEvent("CustomToolAction", "EditToolView", `tool_${id}`);
  }, [id]);

  useEffect(() => {
    if (promptRes.statusCode === 200 && promptRes.data?.prompt) {
      setPrompt(promptRes.data.prompt);
      setIsLoading(false);
    } else if (promptRes.statusCode === 404) {
      navigate("/custom-tools");
    }
  }, [promptRes]);

  const handleCancel = () => {
    navigate("/custom-tools");
  };

  const handleSave = () => {
    navigate("/custom-tools");
  };

  if (isLoading) {
    return (
      <SidebarLayout>
        <div className="flex justify-center items-center h-64">
          <HashLoader size={40} color="#FFC60B" />
        </div>
      </SidebarLayout>
    );
  }

  return (
    <SidebarLayout>
      <div className="max-w-6xl mx-auto px-4">
        <div className="flex justify-between items-center mb-6">
          <div>
            <h1 className="text-3xl font-bold text-gray-800">
              Edit Custom Tool
            </h1>
            <p className="text-gray-600 mt-1">
              Update your custom tool settings
            </p>
          </div>
        </div>

        <PromptEditor
          selectedPrompt={prompt}
          onCancel={handleCancel}
          onSave={handleSave}
        />
      </div>
    </SidebarLayout>
  );
};

export default EditPrompt;
